import React from "react";
import Table from "../../../../../components/TableV2";
import TitleButtons from "../../../../../components/TitleButtons";
import { useVendasSuprimentos } from "./vendasData";

const SuprimentosVendas: React.FC = () => {
  const headers = [
    "PV",
    "Tipo", // 👈 NOVO
    "Código",
    "Nome do Produto",
    "Quantidade",
    "Custo Unitário",
    "Cliente",
    "Data",
    "Hora",
  ];

  const { rows, loading, refresh } = useVendasSuprimentos();

  const columnWidths = [
    "60px", // OS
    "80px", // Tipo 👈 NOVO
    "70px", // Código
    "300px", // Nome
    "50px", // Quantidade
    "70px", // Custo
    "90px", // Técnico
    "90px", // Data
    "60px", // Hora
  ];

  return (
    <div>
      <TitleButtons fullBleedLine title="Comercial - Vendas" />
      <Table headers={headers} rows={rows} columnWidths={columnWidths} />
    </div>
  );
};

export default SuprimentosVendas;
